'use client';

export { default } from './Drawer';
export { default as drawerClasses } from './drawerClasses';
export * from './drawerClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Drawer/index.js
// module id = 846
// module chunks = 22